
import { useBillable } from "@/modules/work/billables/context";
import BillableForm from "@/modules/work/billables/details/form";
import { EvtHeader } from "components/header";
import { useParams } from "react-router-dom";

const UpdateBillable = () => {
    const { billableId } = useParams();

    const { billable } = useBillable();

    return (
        <div className="flex-1">
            <EvtHeader title="Update Billable" />
            <div className="p-6 max-w-md">
                <BillableForm billableId={billableId} job={billable.job} jobId={billable.job.id} type={billable.type} />
            </div>
        </div>
    );
};

export default UpdateBillable;
